import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { Icon, Grid } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
import { useNavigation } from '../../NavigationProvider';

const useStyles = makeStyles(() => {
  return {
    explanationText: {
      marginTop: '30px',
      display: 'flex',
      flexDirection: 'column',
      // width: 'fit-content',
      minWidth: '200px',
      width: '40%',
      marginLeft: '0.5rem',

      '@media (max-width:750px)': {
        width: '100%',
        gap: '30px',
      },

      '@media (max-width:1600px)': {
        minWidth: '30%',
      },

      '@media (min-width:1600px)': {
        padding: '20px',
      },

      '@media (min-width:750px)': {
        maxWidth: '250px',
        padding: '10px',
      },

      '@media (max-width:1500px)': {
        minWidth: '20%',
      },

    },
    explanationImage: {
      borderTopLeftRadius: '10px',
      borderBottomLeftRadius: '10px',
      display: 'block',
      height: '440px',
      width: 'calc(100% - max(200px, 40%))',

      '@media (max-width:750px)': {
        display: 'none',
      },

      '@media (max-width:1600px)': {
        width: 'calc(100% - max(200px, 30%))',
      },

      '@media (max-width:1500px)': {
        width: 'calc(100% - max(200px, 20%))',
      },
    },
    largeTextOrSmall: {
      fontWeight: '600',
      fontSize: 'min(21px, 4vw)',
      fontFamily: 'Roboto',
      lineHeight: '125.19%',

      '@media (max-width:1600px)': {
        fontSize: '20px',
      },
    },
    explanation: {
      borderRadius: '27px',
      background: 'linear-gradient(109.37deg, #FFFFFF 5.49%, rgba(255, 255, 255, 0.51) 103.09%)',
      backdropFilter: 'blur(40px)',
      display: 'flex',
      height: '440px',

      '@media (max-width:1280px)': {
        height: 'auto',
      },
    },
    downloadIconSmall: {
      width: '50px',
      height: '50px',
      left: '48px',
      top: '44px',
      boxShadow: '0px 1.59602px 5.32008px 0px rgba(0, 0, 0, 0.02), 0px 5.36071px 17.86905px 0px rgba(0, 0, 0, 0.03), 0px 24px 55px 0px rgba(0, 0, 0, 0.05)',
      borderRadius: '10px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    container: {
      fontFamily: 'Roboto',
      display: 'flex',
      color: '#484848',
      flexDirection: 'column',
      gap: '25px',
    },
    hoverPointer: {
      '&:hover': {
        cursor: 'pointer',
      },
    },
    smallText: {
      fontWeight: '400',
      fontSize: '16px',
      fontFamily: 'Roboto',
      lineHeight: '125.19%',
    },
    downloadText: {
      background: '#5a7711',
      color: 'white',
      boxShadow: '0px 30.3396px 101.132px rgba(0, 0, 0, 0.05), 0px 6.77675px 22.5892px rgba(0, 0, 0, 0.0298054), 0px 2.01762px 6.72539px rgba(0, 0, 0, 0.0201946)',
      borderRadius: '27px',
      height: '3.1rem',
      display: 'flex',
      width: 'fit-content',
      paddingLeft: '30px',
      paddingRight: '30px',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      marginTop: 'auto',
      marginBottom: '30%',

      transition: 'all .4s',
      '&:hover': {
        paddingLeft: '40px',
        paddingRight: '33px',
        boxShadow: '0px 6.77675px 22.58917px 0px rgba(133, 133, 133, 0.40)',
      },

      '@media (max-width:1450px)': {
        // marginBottom: '5%',
      },
    },
  };
});

export const BottomPartNutri = ({ pdfDownloadLink = null, resultsPageLink = null,
  buttonColor = null, alreadyHadAppointment, appointmentAvailability }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { navigateToPage } = useNavigation();
  const showExplanation = appointmentAvailability || alreadyHadAppointment;
  return (
    <Grid container spacing={ 3 }>
      <Grid
        item
        lg={ showExplanation ? 5 : 12 }
        sm={ 12 }
      >
        <div
          style={ { padding: '20px 30px 1px 30px',
            background: 'white',
            borderRadius: '16px',
            position: 'relative',
            height: '440px' } }
        >
          <div style={ { display: 'flex', alignItems: 'center', gap: '30px' } }>
            <div>
              <Icon className={ clsx(classes.downloadIconSmall) }>
                <img
                  src='/download.svg'
                  alt=''
                />
              </Icon>
            </div>
            <div className={ classes.smallText } style={ { marginTop: '16px' } }>
              {t('Here you will find your personal results report in a printable format.')}
            </div>
          </div>

          <div
            className={ clsx(classes.largeTextOrSmall) }
            style={ { marginTop: '30px',
              fontSize: 'min(20px, 4vw)',
              marginBottom: '5px' } }
          >
            {t('Διατροφογενετική Ανάλυση')}
          </div>

          <div
            className={ clsx(classes.downloadText, classes.smallText, classes.hoverPointer) }
            style={ { ...(null != buttonColor) && { background: buttonColor },
              marginBottom: 0 } }
            aria-hidden='true'
            onClick={ () => { navigateToPage({ pageId: null === pdfDownloadLink ? 'nutriGenetixAnalysisPdfVersion' : pdfDownloadLink }); } }
          >
            {t('download')}
          </div>

          <div>
            <div
              className={ clsx(classes.largeTextOrSmall) }
              style={ {
                fontSize: 'min(20px, 4vw)',
                marginTop: '24px',
              } }
            >
              {t('Πλάνο διατροφής')}
            </div>

            <div
              className={ clsx(classes.downloadText, classes.smallText, classes.hoverPointer) }
              style={ { ...(null != buttonColor) && { background: buttonColor },
                marginBottom: 0,
                marginTop: '5px' } }
              aria-hidden='true'
              onClick={ () => { navigateToPage({ pageId: null === pdfDownloadLink ? 'nutriGenetixNutritionPlanPdfVersion' : pdfDownloadLink }); } }
            >
              {t('download')}
            </div>
          </div>
          <div
            className={ clsx(classes.largeTextOrSmall) }
            style={ {
              fontSize: 'min(20px, 4vw)',
              marginTop: '24px',
            } }
          >
            {t('Συμπληρωμένο Ερωτηματολόγιο')}
          </div>
          <div>
            <div
              className={ clsx(classes.downloadText, classes.smallText, classes.hoverPointer) }
              style={ { ...(null != buttonColor) && { background: buttonColor },
                marginBottom: 0,
                marginTop: '5px' } }
              aria-hidden='true'
              onClick={ () => { navigateToPage({ pageId: 'nutrigenetixQuestionnaireAnswers' }); } }
            >
              {t('Δες το')}
            </div>
          </div>
        </div>

      </Grid>

      {
        showExplanation && (
          <Grid
            item
            lg={ 7 }
            md={ 12 }
          >
            <div className={ classes.explanation }>
              <img
                className={ classes.explanationImage }
                src='/Image_Επεξηγηση-αποτελεσματων_Croped.jpg'
                alt=''
              />
              <div className={ classes.explanationText }>
                <div className={ clsx(classes.largeTextOrSmall) }>
                  {t('explanationOfResults')}
                </div>
                <div
                  className={ classes.smallText }
                  style={ { marginTop: '13px' } }
                >
                  { t('Book a phone appointment with our scientific team to explain the personalized results report.') }
                </div>
                <div
                  className={ clsx(classes.downloadText, classes.smallText, classes.hoverPointer) }
                  style={ {
                    ...(null != buttonColor) && { background: buttonColor }, textAlign: 'center',
                  } }
                  aria-hidden
                  onClick={ () => { navigateToPage({ pageId: null === resultsPageLink ? '' : resultsPageLink }); } }
                >
                  {!alreadyHadAppointment ? <>{t('makeAnAppointment')}</> : <>{t('explanationOfResults')}</>}
                </div>
              </div>
            </div>
          </Grid>
        )
      }

    </Grid>
  );
};
